import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    common: {
      black: "#272727",
      white: "#FFFFFF",
    },
    primary: {
      main: "#524BA3",
      contrastText: "#F5F6FF",
    },
    secondary: {
      main: "#6D71C8",
    },
    text: {
      primary: "#242459",
      secondary: "#757679",
    },
    success: {
      main: "#34C759",
    },
    error: {
      main: "#FE3D2F",
    },
    grey: {
      300: "#E7E7E7",
    },
  },
  typography: {
    fontFamily: 'Lato, "sans-serif"',
  },
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: ({ theme }) => ({
          zIndex: theme.zIndex.drawer - 1,
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "30px",
          fontFamily: "Lato, sans-serif",
          textTransform: "initial",
          fontWeight: "800",
          padding: "12px",
        },
        containedPrimary: {
          boxShadow: "2px 2px 12px -2px rgba(182, 170, 255, 0.8)",
          fontSize: "18px",
          minWidth: "346px",
        },
        text: ({ theme }) => ({
          color: theme.palette.secondary.main,
          fontSize: "16px",
        }),
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: ({ theme }) => ({
          color: theme.palette.primary.main,
        }),
        colorSecondary: ({ theme }) => ({
          color: theme.palette.grey[300],
        }),
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.common.white,
          height: "8px",
        }),
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          height: "8px",
        },
        mark: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme }) => ({
          backgroundColor: theme.palette.common.white,
          color: theme.palette.common.black,
          boxShadow: "2px 2px 12px -2px rgba(182, 170, 255, 0.8)",
          border: `1px solid ${theme.palette.primary.main}`,
        }),
      },
    },
  },
});
